import script from "./NetworksAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworksAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./NetworksAdvisorComponent.vue?vue&type=style&index=0&id=9f9d54c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f9d54c6"]])

export default __exports__